<script lang="ts" setup>
interface SeoArticleProps {
    content: string
}

const props = defineProps<SeoArticleProps>()
const { $t } = useNuxtApp()
const isExpanded = ref<boolean>(false)
const panelId = useId()
const toggleId = useId()
const stateAnnouncement = ref<string>('')

const splitContent = computed<{ visible: string; rest: string }>(() => {
    const html = props.content.trim()
    const firstPClose = html.indexOf('</p>')
    if (firstPClose === -1) {
        return { visible: html, rest: '' }
    }
    const splitAt = firstPClose + 4
    return {
        visible: html.substring(0, splitAt),
        rest: html.substring(splitAt).trim(),
    }
})

const toggle = (): void => {
    isExpanded.value = !isExpanded.value

    stateAnnouncement.value = ''
    setTimeout(() => {
        stateAnnouncement.value = isExpanded.value
            ? $t('obsah rozbalený')
            : $t('obsah zbalený')
    }, 100)
}
</script>

<template>
  <div class="seo-article">
    <!-- eslint-disable vue/no-v-html -->
    <Typo>
      <div
        class="mb-4"
        v-html="splitContent.visible"
      />
    </Typo>
    <div
      v-if="splitContent.rest"
      :id="panelId"
      class="seo-article__rest"
      :class="{ 'seo-article__rest--expanded': isExpanded }"
      role="region"
      :aria-labelledby="toggleId"
    >
      <Typo>
        <div v-html="$formatTableHtml(splitContent.rest)" />
      </Typo>
    </div>
    <!-- eslint-enable vue/no-v-html -->
    <div
      v-if="splitContent.rest"
      class="seo-article__toggle mt-4"
    >
      <a
        :id="toggleId"
        href="#"
        role="button"
        :aria-expanded="isExpanded"
        :aria-controls="panelId"
        @click.prevent="toggle"
      >
        {{ isExpanded ? 'Zobraziť menej' : 'Zobraziť viac' }}
      </a>
    </div>
    
    <Teleport to="body">
      <div
        aria-live="assertive"
        aria-atomic="true"
        class="visually-hidden"
      >
        {{ stateAnnouncement }}
      </div>
    </Teleport>
  </div>
</template>

<style lang="scss" scoped>
@import './SeoArticle.scss';
</style>
